(function () {
    'use strict';

    /**
     *
     * @ngdoc service
     * @name
     *
     * @description
     *
     */
    angular
        .module('targetHours')
        .service('TargetHoursService', TargetHoursService);

    function TargetHoursService(RemoteService,MessageService,EventManagerService,TargetHoursFactory) {

    	var self = this;

        var model={
           searchCriteria: TargetHoursFactory.getSearchCriteria(),
           dataList:[],
           adaptedList:[],
           searchDataList:[],
           saveTargetData :TargetHoursFactory.getSaveRequest()
       };

        self.mode ={
        	saveMode:'SAVE',
        	calMode :'CALCULATE',
        	searchMode:'SEARCH'

        };

    	 self.setSearchCriteria = function (passSearch,dataList) {
            var search = TargetHoursFactory.getSearchCriteria();
            search.cycle = passSearch.cycle == null ? null :passSearch.cycle.cycleId;
            search.acType = passSearch.modelNumber == null ? null :passSearch.modelNumber.modelNumber;
            search.crewType = passSearch.crewType == null ? null :passSearch.crewType.crewTypeCode;
            search.base = passSearch.crewBase == null ? null :passSearch.crewBase.airPortCode;
            search.contractType = passSearch.flexiContract == null ? null : passSearch.flexiContract.contractCode;
            if(dataList!== null){
            	search.fixedCrewData = TargetHoursFactory.setFixedCrewData(dataList);
            	search.calTargetHours = 'Y';
            }
            model.searchCriteria = search;
        };


        self.getTargetHours = function(successFn, errorFn){
            RemoteService.searchTargetHours(model.searchCriteria).then(
                function (response) {
                    if(response.success && !!response.targetHours){
                    	model.searchDataList = response.targetHours;
                        successFn(response);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.saveTargetHours = function(successFn, errorFn){
        	RemoteService.saveTargetHours(model.saveTargetData).then(
        			function (response) {
                        if(response.success){
                            successFn(response);
                        }
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
        	);

        }

        self.setSaveData = function(targetList,srchCriteria){
        	var save = TargetHoursFactory.getSaveRequest();
        	save.cycleID = srchCriteria.cycle == null ? null :srchCriteria.cycle.cycleId;
        	save.targetHours = TargetHoursFactory.adaptSaveData(targetList);
        	model.saveTargetData = save;
        }

        self.getFormattedData = function(List) {
			model.adaptedList = TargetHoursFactory.getFormattedList(List);
			return model.adaptedList;
		}

        self.getMappedData = function(param){
        	var filter = {};
        	 if (!angular.isUndefined(param.modelNumber) && param.modelNumber !== null && param !== 'ANY') {
                 filter['modelNumber'] = param.modelNumber;
             }
        	return _.filter(angular.copy(model.searchDataList), filter);
        }

        }

})();
